package one.healthium.paywall.ui.scheduler

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.NonRestartableComposable
import androidx.lifecycle.Lifecycle
import androidx.lifecycle.LifecycleEventObserver
import androidx.lifecycle.compose.LocalLifecycleOwner
import androidx.lifecycle.lifecycleScope
import co.touchlab.kermit.Logger
import kotlinx.coroutines.launch
import one.healthium.domain.paywall.models.RemarketingOffer
import org.koin.compose.koinInject

@Composable
@NonRestartableComposable
fun RemarketingEffect(offers: List<RemarketingOffer>?) {
    val lifecycleOwner = LocalLifecycleOwner.current
    val remarketingManager = koinInject<RemarketingManager>()

    DisposableEffect(lifecycleOwner, offers) {
        val observer = LifecycleEventObserver { _, event ->
            Logger.d("event: $event, offers: $offers")
            if (event == Lifecycle.Event.ON_STOP && !offers.isNullOrEmpty()) {
                lifecycleOwner.lifecycleScope.launch { remarketingManager.schedule(offers) }
            } else if (event == Lifecycle.Event.ON_START) {
                // TODO cancel only remarketing notifications
                remarketingManager.cancelAll()
            }
        }
        lifecycleOwner.lifecycle.addObserver(observer)

        onDispose {
            lifecycleOwner.lifecycle.removeObserver(observer)
        }
    }
}